import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";

import { useHistory, useRouteMatch, useLocation, Link } from "react-router-dom";
import FilterListSharpIcon from "@material-ui/icons/FilterListSharp";
import {
  investmentDetailsPath,
  editInvestPath,
  handleSort,
  getDateTime,
  getDate,
} from "../utils/varialbles";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import http from "../services/httpService";
import SearchBar from "material-ui-search-bar";
import { SvgIcon } from "@material-ui/core";
import useFilter from "../components/sideFilter";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
import { Rnd } from "react-rnd";
import toast from "react-hot-toast";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

import {
  MenuItem,
  Select,
  InputLabel,
  TextField,
  ListItemIcon,
  Checkbox,
  ListItemText,
  TableSortLabel,
} from "@material-ui/core";
import CallIcon from "@material-ui/icons/Call";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    position: "relative",
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function OnboardingOverView({
  showProgressBar,
  passRecords,
  recordsCount,
  handleCloseModal,
  getSelectedId,
  getState,
  data,
}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("investmentrowsperpage") || "10"
  );
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  // const [anchorEl, setAnchorEl] = React.useState(true);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();
  const myparam = location.state;

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isFilterData, setIsFilterData] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState([]);
  const [isFilterString, setIsFilterString] = useState(
    localStorage.getItem("selectedonbaordingfiltersdata") || ""
  );
  const [isRange, setIsRange] = React.useState(false);
  const [filterTrue, setFilterTrue] = useState(false);
  // Checkbox State
  const [isCheckboxSelected, setIsCheckboxSelected] = useState([]);
  // const [apiReq, setapiReq] = useState();

  const [isSelectedData, setIsSelectedDatas] = useState(
    localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
      ? [
          {
            id: 1,
            options: [],
            name: "Subscription Status",
          },
          {
            id: 2,
            data: { equalTo: "" },
            name: "Current Renewal Date",
          },
          {
            id: 3,
            data: { equalTo: "" },
            name: "Subscription Date",
          },
        ]
      : [
          {
            id: 1,
            options: [],
            name: "Country",
          },
          {
            id: 2,
            options: [],
            name: "State",
          },
          {
            id: 3,
            options: [],
            name: "City",
          },
          {
            id: 4,
            options: [],
            name: "Subscription Status",
          },
          {
            id: 5,
            data: { equalTo: "" },
            name: "Current Renewal Date",
          },
          {
            id: 6,
            data: { equalTo: "" },
            name: "Subscription Date",
          },
          {
            id: 7,
            data: { equalTo: "" },
            name: "Payment Date",
          },
          {
            id: 8,
            data: { equalTo: "" },
            name: "Signup Date",
          },
          {
            id: 9,
            data: { equalTo: "" },
            name: "Last Advised Date",
          },
          {
            id: 10,
            options: [],
            name: "RM Name",
          },
          {
            id: 11,
            options: [],
            name: "BGT Name",
          },
          {
            id: 12,
            options: [],
            name: "CRT Name",
          },
          {
            id: 13,
            options: [],
            name: "Service Type",
          },
          {
            id: 14,
            data: { equalTo: "" },
            name: "Last Activity Date",
          },

          {
            id: 15,
            options: [],
            name: "KYC Status",
          },
          {
            id: 16,
            options: [],
            name: "Personal Profile Status",
          },
          {
            id: 17,
            options: [],
            name: "CDT Status",
          },
          {
            id: 18,
            options: [],
            name: "Check-in Status",
          },
          {
            id: 19,
            options: [],
            name: "CRT Status",
          },
          {
            id: 20,
            options: [],
            name: "Onboarding Status",
          },
          {
            id: 21,
            options: [],
            name: "Demat Link",
          },
          {
            id: 22,
            data: { equalTo: "" },
            name: "Goals set",
          },
          {
            id: 23,
            options: [],
            name: "Prospect Source",
          },
          {
            id: 24,
            options: [],
            name: "Preferred Language",
          },
          {
            id: 25,
            data: { equalTo: "" },
            name: "Invested Value",
          },
          {
            id: 26,
            data: { equalTo: "" },
            name: "Invested Portfolio Returns",
          },
          {
            id: 27,
            data: { equalTo: "" },
            name: "Advised Value",
          },
          {
            id: 28,
            data: { equalTo: "" },
            name: "Advised Portfolio Returns",
          },
          {
            id: 29,
            data: { equalTo: "" },
            name: "Annual Income",
          },
          {
            id: 30,
            data: { equalTo: "" },
            name: "All Renewal Dates",
          },
          {
            id: 31,
            options: [],
            name: "Customer Tag",
          },
        ]
  );

  const [columns, setColumns] = useState(
    localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
      ? [
          {
            headerName: "Mobile",
            id: "mobile",
            show: true,
            minWidth: 150,
            type: "call",
          },
          {
            headerName: "First Name",
            id: "First_Name",
            show: true,
            minWidth: 150,
          },
          {
            headerName: "Last Name",
            id: "Last_Name",
            show: true,
            minWidth: 150,
          },
          { headerName: "Email", id: "email", show: true, minWidth: 100 },

          {
            headerName: "Subscription Date",
            id: "sub_date",
            show: true,
            minWidth: 150,
          },
          {
            headerName: "Subscription Status",
            id: "sub_status",
            show: true,
            minWidth: 150,
          },
          { headerName: "Renewal Date", id: "exp", show: true, minWidth: 200 },
          { headerName: "User Id", id: "UserID", show: true, minWidth: 100 },
        ]
      : [
          // { headerName: "Action", field: "actions", show: true, width: 100, disableClickEventBubbling: true, pinnable: true,
          //   renderCell: (params) => (
          //     <IconButton
          //       onClick={(event) => {
          //         event.ignore = true;
          //         // ("delete");
          //         viewProspectDetails(params.row)
          //         // (param) => viewProspectDetails(param.row)
          //       }}
          //     >
          //       <VisibilityIcon />
          //     </IconButton>
          //   )
          // },
          {
            headerName: "Mobile",
            id: "mobile",
            show: true,
            minWidth: 150,
            type: "call",
          },
          {
            headerName: "First Name",
            id: "First_Name",
            show: true,
            minWidth: 150,
          },
          {
            headerName: "Last Name",
            id: "Last_Name",
            show: true,
            minWidth: 150,
          },
          { headerName: "Email", id: "email", show: true, minWidth: 100 },
          {
            headerName: "Prospect Source",
            id: "leadsource",
            show: true,
            minWidth: 150,
          },
          { headerName: "RM Name", id: "exec", show: false, minWidth: 150 },
          { headerName: "BGT Name", id: "bgt", show: false, minWidth: 150 },
          {
            headerName: "Subscription Date",
            id: "sub_date",
            show: false,
            minWidth: 150,
          },
          {
            headerName: "Subscription Status",
            id: "sub_status",
            show: false,
            minWidth: 150,
          },
          { headerName: "Status", id: "status", show: false, minWidth: 150 },
          {
            headerName: "Check-in Status",
            id: "checkin_status",
            show: false,
            minWidth: 150,
          },

          { headerName: "User Id", id: "UserID", show: false, minWidth: 100 },
          { headerName: "Renewal Date", id: "exp", show: false, minWidth: 200 },
          {
            headerName: "Last Login",
            id: "last_log",
            show: false,
            minWidth: 150,
          },
          {
            headerName: "App Downloaded",
            id: "App_Downloaded",
            show: false,
            minWidth: 150,
          },
          { headerName: "Country", id: "Country", show: false, minWidth: 150 },
          {
            headerName: "No Of Reviews Left",
            id: "remaininginvreviewreqs",
            show: false,
            minWidth: 150,
          },
          {
            headerName: "Number Of Investments Requests Left",
            id: "remaininginvreqs",
            show: false,
            minWidth: 150,
          },
          {
            headerName: "Number Of Referrals",
            id: "no_refs",
            show: false,
            minWidth: 150,
          },
          {
            headerName: "Demat Status",
            id: "demat_link",
            show: false,
            minWidth: 150,
          },
          { headerName: "Tasks", id: "custtasks", show: false, minWidth: 100 },
          { headerName: "ID", id: "id", show: false, minWidth: 100 },
          {
            headerName: "Payment Date",
            id: "pay_date",
            show: false,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "Preferred Language",
            id: "language",
            show: false,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "State",
            id: "state",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "City",
            id: "city",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "CRT Executive",
            id: "crt_executive",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "Service Type",
            id: "service_plan",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "CRT Status",
            id: "crt_status",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "Onboarding Status",
            id: "onboarding_status",
            show: true,
            minWidth: 150,
            // format: "Date",
          },
          {
            headerName: "Customer Tag",
            id: "tag",
            show: true,
            minWidth: 150,
          },
          {
            headerName: "Advice Limit Left",
            id: "remaining_invlimit",
            show: true,
            minWidth: 150,
          },
          // { headerName: "Preferred Language", field: "", show: false, width: 150  },
          // { headerName: "GetBack Date", field: "", show: false, width: 150  },
          // { headerName: 'Tasks', field: 'custtasks', show: false, width: 300,
          // renderCell: (props) => (
          //   // (props, props.value),
          //   props.value ?
          //   <select
          //   style={{paddingLeft:"0px", marginLeft:"5px", border:"1px solid #ccc", height:"25px"}}
          //   onClick={(event => event.preventDefault())}
          //   >
          //       {props.value.map(item=>
          //         <option>{item}</option>
          //         )}
          //     </select> : ""
          //   ),
          // },
          // { headerName: "Tasks", field: "custtasks", show: false, width: 150 },
          // { headerName: "SignUp Date", field: "sub_date", show: false, width: 150  },
          // {headerName:"Get Back Status", field:"color", show: false, width: 150  },
          // { headerName: "Last Interaction Date", field: "", show: false, width: 150  },
          // { headerName: "Invested Portfolio Profit", field: "", show: false, width: 150  },
          // { headerName: "Adviced Portfolio Profit", field: "", show: false, width: 150  }
        ]
  );

  //Update values based on keys for the column Onboarding Status
  const onboardingStatusMap = {
    "0KP": "KYC Pending",
    "1KC": "KYC Completed",
    "2RR": "Request Raised",
  };

  // let newCol = columns.map(col => col);
  // (columns);

  let staticCols = [
    "ID",
    "Mobile",
    "First Name",
    "Last Name",
    "Email",
    "Prospect Source",
  ];

  let finalDropCols = columns.filter((item) => {
    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      return item.headerName;
    } else {
      if (!staticCols.includes(item.headerName)) {
        return item.headerName;
      }
    }
  });
  // (finalDropCols);

  const gridOptions = {
    filter: "false",
    pagination: false,
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    variant: "menu",
  };

  const [selected, setSelected] = useState([]);
  console.log(selected, "selected");

  const [counter, setCounter] = useState(0);

  useEffect(() => {
    setCounter(counter + 1);
    localStorage.setItem("selectedonbaordingfiltersdata", isFilterString);
    localStorage.removeItem("selectedfiltersdata");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");
    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
    var getObj = JSON.parse(localStorage.getItem("onboardingFilter"));
    // ('am local', getObj, isSelectedData);
    if (getObj !== null) {
      for (var e = 0; e < isSelectedData.length; e++) {
        if (isSelectedData[e]) {
          for (var f = 0; f < getObj.length; f++) {
            if (isSelectedData[e].id === getObj[f].id) {
              isSelectedData[e].options = getObj[f].options;

              // ("amv", isSelectedData)
            }
          }
        }
      }
    } else {
    }

    if (filterTrue === true) {
      setIsFilterString(getFilterParams());
    } else {
    }

    // applied filter
    if (data === true) {
      setIsCheckboxSelected([]);
      getData();
    }

    // call applied filter
    // getData();
    let filtermatchString = getFilterParams();
    if (counter >= 2) {
      if (filtermatchString === isFilterString) {
        getData();
      }
    }
  }, [isFilterString, appliedFilter, data]);
  // (counter,'counter');
  console.log(columns);
  useEffect(() => {
    if (
      localStorage.getItem("empRole") === "MF Manager" ||
      localStorage.getItem("empRole") === "MF Executive" ||
      localStorage.getItem("empRole") === "Franchise"
    ) {
      investmentColumns();
    } else {
      investmentColumns();
    }
    // getData();
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage]);

  useEffect(() => {}, [showProgressBar, passRecords]);

  const investmentColumns = () => {
    http.get("/investorempcolumns").then((response) => {
      // (response);
      if (response.data.statusCode === 0) {
        // (response.data.data);
        let value = response.data.data;
        console.log(value);
        setSelected(response.data.data);
        // let newCols = columns.map((item) => {
        //   let findSelect = value.find((list) => {
        //     if (list === item.headerName) {
        //       // return item;
        //       item.show = true;
        //       // (item);
        //       return item;
        //       // setColumns(item);
        //     } else {
        //       item.show = false;
        //     }
        //   });
        //   return newCols;
        // });

        // let newCols = columns.map((item) => {
        //   const show = value.includes(item.headerName);
        //   return { ...item, show: true };
        // });

        let newCols = columns.map((item) => {
          const show = (value.length > 0 ? value : staticCols).includes(
            item.headerName
          );
          return { ...item, show };
        });

        setColumns(newCols);
      } else {
        toast.error("Columns not fetched!");
      }
    });
  };

  // const handleColChange = (event) => {
  //   const value = event.target.value;
  //   setSelected(value);
  //   let newCols = columns.map((item) => {
  //     let findSelect = value.find((list) => {
  //       if (list === item.headerName) {
  //         // return item;
  //         item.show = true;
  //         // (item);
  //         return item;
  //         // setColumns(item);
  //       } else {
  //         item.show = false;
  //       }
  //     });
  //     return newCols;
  //   });

  //   // let parsedVal = JSON.parse(value);
  //   localStorage.setItem("slectInvestedCols", value);
  // };

  const handleColChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    // let newCols = columns.map((item) => {
    //   let findSelect = value.find((list) => {
    //     if (list === item.headerName) {
    //       // return item;
    //       item.show = true;
    //       // (item);
    //       return item;
    //       // setColumns(item);
    //     } else {
    //       item.show = false;
    //     }
    //   });
    //   return newCols;
    // });

    setSelected(value);

    // let newCols = columns.map((item) => {
    //   const show = value.includes(item.headerName);
    //   return { ...item, show };
    // });

    let newCols = columns.map((item) => {
      const show =
        value.includes(item.headerName) || staticCols.includes(item.headerName);
      return { ...item, show };
    });
    setColumns(newCols);

    localStorage.setItem("slectProspectCols", JSON.stringify(value));
  };

  let filteredCol = columns.filter((data) => {
    if (
      (localStorage.getItem("empRole") === "MF Manager" ||
        localStorage.getItem("empRole") === "MF Executive" ||
        localStorage.getItem("empRole") === "Franchise") &&
      staticCols.includes(data.headerName)
    ) {
      return data;
    } else if (data.show) {
      return data;
    }
  });

  // if(localStorage.getItem("empRole") === "MF Manager" ||
  // localStorage.getItem("empRole") === "MF Executive" ||
  // localStorage.getItem("empRole") === "Franchise") {
  //   return data;
  // }

  console.log(filteredCol, "filteredCol");
  console.log(selected, "selected");
  console.log(columns, "columns");

  const saveColumns = () => {
    let finalCols = staticCols.concat(selected);
    let sendFinalCols = [...new Set(finalCols)];
    // (finalCols);
    // (sendFinalCols);

    let finalObjet = {
      emp_id: localStorage.getItem("employee_id"),
      columns: sendFinalCols,
    };
    http
      .post("/investorempcolumns", finalObjet)
      .then((response) => {
        if (response.data.statusCode === 0) {
          toast.success(response.data.data);
          setShowMenuCol(false);
        } else {
          toast.error("Columns not saved!");
        }

        // setFromObject(form)
      })
      .catch((error) => {
        console.log("error");
      });
  };

  const form = {
    Country: "",
    EFG_Score: "",
    EFG_Score__condition: "lte",
  };
  const [formObject, setFormObject] = React.useState(form);

  const applyFilter = (e) => {
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };

  const handleMenuClose = () => {
    // ('closefunction')
    // setAnchorEl(false);
    setIsMenuOpen(false);
  };

  const openFilter = (e) => {
    // setIsMenuOpen(true);
    setIsFilterOpen(true);

    // let currentTarget = e.currentTarget;
    // setAnchorEl(currentTarget);
    // setAnchorEl(true);
  };
  const closeFilter = () => {
    setIsFilterOpen(false);
  };

  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };

  const cancelSearch = (searchVal) => {
    setSearched(searchVal);
    let abc = "";
    getData(abc);
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    // (searchedVal)
    setSearched(searchedVal);
    setPage(0);
  };
  const requestSearching = () => {
    if (searched === undefined || searched.length < 4) {
      toast.error("Please Enter more than 3 characters to search");
    } else {
      getData(searched);
    }
  };

  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...orignalRows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setOriginalRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    localStorage.setItem("investmentrowsperpage", +event.target.value);
  };

  const viewProspectDetails = (object) => {
    object.page = page;
    history.push({
      pathname: investmentDetailsPath,
      state: object,
    });
  };

  // added the below line --step2
  const [Filter, filterString, passFilters, passData] = useFilter();

  const [totalRowCount, setTotalRowCount] = React.useState(0);

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  const getData = (newQuery) => {
    toast.loading("Please wait...");

    const baseURL = "/onboarding_manager";
    setOriginalRows([]);
    setRows([]);
    http
      .get(getPaginationURL(baseURL, newQuery) + isFilterString)
      .then((response) => {
        // added filterString concat step3
        // ('rowoow');
        // (response);
        // http.get("/investment_manager").then((response) => {
        toast.dismiss();

        if (
          response &&
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          // ('ooooooo');
          if (!isFilterString);

          // let tempDta = response.data.data;

          const datas = response.data.filter;
          // const wholeData = response.data.filter;
          let rawData = datas.map((es, index) => {
            es.id = index + 1;
            return es;
          });
          // ('am raw data', selectedDatas);

          setIsFilterData(rawData); // added if condition step4

          const tempDta = response.data.Data;

          let finalData = [];
          let tempStatusDta = tempDta.map((item, index) => {
            const swapValue = (item) => {
              Object.keys(item).forEach((key) => {
                // (Object.keys(item));
                if (!item[key]) {
                  item[key] = "N/A";
                }
              });
            };
            swapValue(item);

            finalData.push((item.sub_date = getDateTime(item.sub_date)));
            finalData.push((item.pay_date = getDateTime(item.pay_date)));
            finalData.push((item.exp = getDateTime(item.exp)));
            finalData.push((item.last_log = getDateTime(item.last_log)));
            // (item.exp);
            // (getDate(item.exp));

            if (item.status === "P") {
              finalData.push((item.status = "Onboarding Pending"));
            } else if (item.status === "S") {
              finalData.push((item.status = "Onboarding Started"));
            } else if (item.status === "C") {
              finalData.push((item.status = "Onboarding Completed"));
            } else if (item.status === "null") {
              finalData.push((item.status = "N/A"));
            }
            if (item.App_Downloaded === false) {
              finalData.push((item.App_Downloaded = "N/A"));
            } else if (item.App_Downloaded === true) {
              finalData.push((item.App_Downloaded = "True"));
            }

            // else {
            //   finalData.push(item.status = "N/A");
            // }

            return item;
          });
          setOriginalRows(tempDta);
          setRows(tempDta);
          setTotalRowCount(response.data.totalRowCount);
        } else {
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      });
  };

  const editInvest = (object) => {
    // (object);
    object.page = page;
    history.push({
      pathname: editInvestPath,
      state: object,
    });
  };

  const [menuCol, setShowMenuCol] = useState(false);

  const showMenuFilter = (e) => {
    setShowMenuCol((val) => !val);
  };

  // handle filter modal change
  const handleSelectChange = (v, id, meta) => {
    // ('am ', v, id);
    if (v === "range") {
      setIsRange(true);
    } else {
      // setIsRange(false);
    }
    setIsSelectedDatas((fstate) => {
      const newState = isFilterData.map((x) => {
        if (x.id === id) {
          //check the type and add value according to the value.
          // if(x.type === 'number'){
          //     return ({
          //         name: x.name,
          //         id: x.id,
          //         value: parseFloat(v),
          //         // options: v
          //     })
          // }

          if (x.type === "select") {
            return {
              name: x.name,
              id: x.id,
              options: v,
            };
          } else if (x.type === "radio") {
            return {
              name: x.name,
              id: x.id,
              options: [v],
            };
          } else if (x.type === "date" || x.type === "number") {
            if (meta === "option") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              let currentValue = fstateObject.data.lessThan
                ? fstateObject.data.lessThan
                : "";
              currentValue = fstateObject.data.greaterThan
                ? fstateObject.data.greaterThan
                : "";
              currentValue = fstateObject.data.equalTo
                ? fstateObject.data.equalTo
                : "";
              currentValue = fstateObject.data.greaterThanEqual
                ? fstateObject.data.greaterThanEqual
                : "";
              currentValue = fstateObject.data.lessThanEqual
                ? fstateObject.data.lessThanEqual
                : "";
              currentValue = fstateObject.data.range
                ? fstateObject.data.range
                : "";
              // (currentValue);
              return { id, name: x.name, data: { [v]: currentValue } };
            } else if (meta === "value") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              return { id, name: x.name, data: { [currentOption]: v } };
            } else if (meta === "rangeFrom") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${v},${toValue}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `${v},`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            } else if (meta === "rangeTo") {
              const fstateObject = fstate.find((filter) => filter.id === x.id);
              const currentOption = Object.keys(fstateObject.data)[0];
              const currentValue =
                fstateObject.data[Object.keys(fstateObject.data)[0]];
              if (currentValue.includes(",")) {
                const fromValue = currentValue.split(",")[0];
                const toValue = currentValue.split(",")[1];
                const encodedDate = `${fromValue},${v}`;
                // ({currentValue, v, fromValue, toValue, encodedDate});
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              } else {
                const encodedDate = `,${v}`;
                // (currentValue, v, encodedDate)
                return {
                  id,
                  name: x.name,
                  data: { [currentOption]: encodedDate },
                };
              }
            }
          }
        } else {
          return fstate.find((filter) => filter.id === x.id);
        }
      });
      // (newState, 'am new state');
      return newState;
    });
  };

  const applyFilters = () => {
    setFilterTrue(true);

    const cleanedFilterState = isSelectedData.filter((x) => {
      if (x.options) {
        // for select and radios
        return x.options.length > 0;
      } else if (x.data) {
        // for date
        return (
          x.data.greaterThan ||
          x.data.lessThan ||
          x.data.equalTo ||
          x.data.lessThanEqual ||
          x.data.greaterThanEqual ||
          x.data.range
        );
      } else if (x.value) {
        // for number type
        //x.value is a number u cant get length of it
        return x.value.toString().length > 0;
      }
      // (x);
    });

    localStorage.setItem(
      "onboardingFilter",
      JSON.stringify(cleanedFilterState)
    );

    setAppliedFilter(cleanedFilterState);
    if (appliedFilter !== 0) {
      appliedFilter.map((x) => {
        if (x.type === "select" || x.type === "radio") {
          const selectFilerobject = {
            id: x.id,
            options: [x.options],
            name: x.name,
          };
          isSelectedData.push(selectFilerobject);
        } else if (x.type === "date" || x.type === "number") {
          // var today = new Date();
          const emptyFilterObject = {
            id: x.id,
            data: {
              equalTo: "",
            },
            name: x.name,
          };
          isSelectedData.push(emptyFilterObject);
        }
      });
    }
    setIsFilterString(getFilterParams());

    // ("filter");
    // props.setOpen(false);
    setIsFilterOpen(false);
    // getData()
  };
  const shouldNameDisplay = (filter) => {
    // const exceptionCase = location.url
    return filter.showName ? filter.name : "";
  };

  const getFilterParams = () => {
    //convert the appliedFilterState to query params string (without ? mark) using the following convertion format
    // status - comma separated values, name is Status in the object
    // RM - comma separated values, name is RM Name in the object
    // signup_lt - less than signup date - date format, name is Signup Date and lessThan property is present with date
    // signup_gt - greater than signup date -date format, name is SignupDate and greaterThan property is present with date
    // getback_lt - less than get back date - date format, name is Get Back Date and lessThan property is present with date
    // getback_gt - greater than get back date -date format name is Get Back Date and greaterThan property is present with date
    // convert appliedFilterState to query params string
    // appliedFilterState contains objects with properties: name, options[ARRAY] (or data[OBJECT] for time)

    const conversionFormatFor_select = {
      "RM Name": "assigned_executive__empfname__in",
      // "RM name": "rm_name", // This is commenting for Prospect Overview Filter Fix
      "BGT Name": "old_assigned_executive__empfname__in",
      "CDT Status": "cdt_status__in",
      "Check-in Status": "checkin_status__in",
      "Prospect Source": "signupfrom__in",
      "Service Type": "serviceType",
      "Referee Visits": "refree_visits",
      "Successful referrals": "success_refs",
      "Referrals Shared": "ref_shared",
      "Referral Bonus": "ref_bonus",
      Country: "custcountry__locname__in",
      State: "custstate__in",
      City: "custcity__in",
      "Issue Type": "issueType",
      Reporter: "reporter",
      "Assigned To": "assignedTo",
      Severity: "severity",
      Frequency: "frequency",
      "Preferred Language": "customer_language__in",
      "Critical CDT Reminders": "ccdtReminders",
      "Subscription Status": "subscription_status",
      Conditions: "filter_data",
      "KYC Status": "kyc_status",
      // "Personal profile Status": "pp_status",
      "Personal Profile Status": "pp_status",
      "Demat Link": "demat_link",
      "Task Status": "task_status",
      "CRT Name": "crt_executive__empfname__in",
      "Service Type": "service_id",
      "CRT Status": "crt_status__in",
      "Onboarding Status": "onboarding_status__in",
      "Customer Tag": "tag__in",
    };
    const conversionFormatFor_date = {
      "Expiry Date": "expiryDate_",
      "Signup Date": "createddt__",
      // "Sign up date": "signup_", // This is commenting for Prospect Overview Filter Fix
      "Get Back Date": "getback_",
      "Created Date": "createdDate_",
      "Call Date": "callDate_",
      "Date Time": "callDate_",
      // "Referrals Shared": "ref_shared_",
      // "Renewal Date": "servexpdt__date__",
      "Current Renewal Date": "servexpdt__",
      "All Renewal Dates": "renewaldt__",
      "Subscription Date": "subdt__",
      "Payment Date": "created__",
      // "Last login date": "lastlogin_",// This is commenting for Investment Overview Filter Fix
      "Last Login Date": "last_login__",
      // "Goals set": "goals_set_value_",
      ref_shared_value: "ref_shared_value_",
      ref_bonus_value: "ref_bonus_value_",
      refree_visits_value: "refree_visits_value_",
      success_refs_value: "success_refs_value_",
      "Last Activity Date": "cust__custlastactivity__",
      "Last Advised Date": "last_advised__",
      "Last Activity Date": "custlastactivity__",
    };
    const conversionFormatFor_number = {
      "Goals set": "goals_count",
      "Invested Value": "totalinvestedval",
      "Invested Portfolio Returns": "totalinvestedgainper",
      "Advised Value": "totaladvisedval",
      "Advised Portfolio Returns": "totaladvisedgainper",
      "Annual Income": "income",
      // "Goals set" : "goals_set_value_"
      // "ref_shared_value": "ref_shared_value",
      // "ref_bonus_value" : "ref_bonus_value",
      // "refree_visits_value": "refree_visits_value",
      // "success_refs_value": "success_refs_value"
    };

    const filterParams = {};
    // (filterParams);

    appliedFilter.map((filter) => {
      let nonDateFilters = [
        "Goals set",
        "Invested Value",
        "Invested Portfolio Returns",
        "Advised Value",
        "Advised Portfolio Returns",
        "Annual Income",
      ];
      if (filter.options) {
        // condition it based on type of filter rather than options or data props
        // (filter.options);
        // (filter);
        // (filter.options.map(x=>x))
        // (filter.options.map(x=>x).join(','))
        filterParams[conversionFormatFor_select[filter.name]] = filter.options
          .map((x) => x)
          .join(",");
        //
      } else if (filter.data && nonDateFilters.includes(filter.name)) {
        // console.log("successful");
        let suffix;
        if (Object.keys(filter.data)[0] === "greaterThan") {
          suffix = "__gt";
        } else if (Object.keys(filter.data)[0] === "lessThan") {
          suffix = "__lt";
        } else if (Object.keys(filter.data)[0] === "equalTo") {
          suffix = "";
        } else if (Object.keys(filter.data)[0] === "lessThanEqual") {
          suffix = "__lte";
        } else if (Object.keys(filter.data)[0] === "greaterThanEqual") {
          suffix = "__gte";
        } else if (Object.keys(filter.data)[0] === "range") {
          suffix = "__range";
        }
        // (filter);
        // (Object.keys(filter.data)[0]);
        filterParams[conversionFormatFor_number[filter.name] + suffix] =
          filter.data[Object.keys(filter.data)[0]];
      } else {
        let suffix;
        if (Object.keys(filter.data)[0] === "greaterThan") {
          suffix = "gt";
        } else if (Object.keys(filter.data)[0] === "lessThan") {
          suffix = "lt";
        } else if (Object.keys(filter.data)[0] === "equalTo") {
          suffix = "date";
        } else if (Object.keys(filter.data)[0] === "lessThanEqual") {
          suffix = "date__lte";
        } else if (Object.keys(filter.data)[0] === "greaterThanEqual") {
          suffix = "gte";
        } else if (Object.keys(filter.data)[0] === "range") {
          suffix = "date__range";
        }
        // (filter);
        // (Object.keys(filter.data)[0]);
        filterParams[conversionFormatFor_date[filter.name] + suffix] =
          filter.data[Object.keys(filter.data)[0]];
      }

      // else if (filter.value) {
      //   filterParams[conversionFormatFor_number[filter.name]] = filter.value;
      // }
    });
    //return the query string with the filterParams
    // (("&"+Object.keys(filterParams).map(x=>x+"="+filterParams[x]).join('&')));
    // const params = Object.keys(filterParams)
    //   .map((x) => x + "=" + filterParams[x])
    //   .join("&");
    // return params ? "&" + params : "";

    const params = Object.entries(filterParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");
      
      return params ? "&" + params : "";
  };
  const clearFilters = () => {
    localStorage.getItem("empRole") === "MF Manager" ||
    localStorage.getItem("empRole") === "MF Executive" ||
    localStorage.getItem("empRole") === "Franchise"
      ? setIsSelectedDatas([
          {
            id: 1,
            options: [],
            name: "Subscription Status",
          },
          {
            id: 2,
            data: { equalTo: "" },
            name: "Current Renewal Date",
          },
          {
            id: 3,
            data: { equalTo: "" },
            name: "Subscription Date",
          },
        ])
      : setIsSelectedDatas([
          {
            id: 1,
            options: [],
            name: "Country",
          },
          {
            id: 2,
            options: [],
            name: "State",
          },
          {
            id: 3,
            options: [],
            name: "City",
          },
          {
            id: 4,
            options: [],
            name: "Subscription Status",
          },
          {
            id: 5,
            data: { equalTo: "" },
            name: "Current Renewal Date",
          },
          {
            id: 6,
            data: { equalTo: "" },
            name: "Subscription Date",
          },
          {
            id: 7,
            data: { equalTo: "" },
            name: "Payment Date",
          },
          {
            id: 8,
            data: { equalTo: "" },
            name: "Signup Date",
          },
          {
            id: 9,
            data: { equalTo: "" },
            name: "Last Advised Date",
          },
          {
            id: 10,
            options: [],
            name: "RM Name",
          },
          {
            id: 11,
            options: [],
            name: "BGT Name",
          },
          {
            id: 12,
            options: [],
            name: "CRT Name",
          },
          {
            id: 13,
            options: [],
            name: "Service Type",
          },
          {
            id: 14,
            data: { equalTo: "" },
            name: "Last Activity Date",
          },

          {
            id: 15,
            options: [],
            name: "KYC Status",
          },
          {
            id: 16,
            options: [],
            name: "Personal Profile Status",
          },
          {
            id: 17,
            options: [],
            name: "CDT Status",
          },
          {
            id: 18,
            options: [],
            name: "Check-in Status",
          },
          {
            id: 19,
            options: [],
            name: "CRT Status",
          },
          {
            id: 20,
            options: [],
            name: "Onboarding Status",
          },
          {
            id: 21,
            options: [],
            name: "Demat Link",
          },
          {
            id: 22,
            data: { equalTo: "" },
            name: "Goals set",
          },
          {
            id: 23,
            options: [],
            name: "Prospect Source",
          },
          {
            id: 24,
            options: [],
            name: "Preferred Language",
          },
          {
            id: 25,
            data: { equalTo: "" },
            name: "Invested Value",
          },
          {
            id: 26,
            data: { equalTo: "" },
            name: "Invested Portfolio Returns",
          },
          {
            id: 27,
            data: { equalTo: "" },
            name: "Advised Value",
          },
          {
            id: 28,
            data: { equalTo: "" },
            name: "Advised Portfolio Returns",
          },
          {
            id: 29,
            data: { equalTo: "" },
            name: "Annual Income",
          },
          {
            id: 30,
            data: { equalTo: "" },
            name: "All Renewal Dates",
          },
          {
            id: 31,
            options: [],
            name: "Customer Tag",
          },
        ]);
    localStorage.removeItem("selectedonbaordingfiltersdata");
    localStorage.removeItem("onboardingFilter");
  };
  // (columns);
  const parseRangeValue = (doubleDate, fromTo) => {
    // value={parseRangeValue(filterState.find(x=>x.id===filter.id)?.data[Object.keys(filterState.find(x=>x.id===filter.id)?.data || {})[0]])}
    // doubleDate Format is 2020-05-30,2020-07-31
    // (doubleDate)
    // (doubleDate.split(',')[0])
    if (fromTo === "from") {
      return doubleDate.split(",")[0];
    } else {
      return doubleDate.split(",")[1];
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const [singleRow, setSingleRow] = useState("");
  const openModel = (e, row) => {
    setSingleRow(row);
    setOpen(true);
  };
  const submitCall = () => {
    callCustomer();
    setOpen(false);
  };

  const callCustomer = (e) => {
    http
      .get("/callrequest?cust_id=" + singleRow.customer_id + "&location=I")
      .then((res) => {
        if (res && res.data && res.data.Data && res.data.statusCode === 0) {
          toast.success(
            "Call Request Placed successfully,Please wait for the call..!"
          );
        } else {
          toast.error("Call Request Failed");
        }
      })
      .catch((err) => {
        toast.error("Call Request Failed");
      });
  };

  // get current date and time
  let curr = new Date();
  curr.setDate(curr.getDate());
  let getCurrentdate = curr.toISOString().substring(0, 10);
  let currentDay = new Date().toString().split(" ").splice(1, 3).join(" ");
  let currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  // checkbox selection
  const isSelected = (id) => isCheckboxSelected.indexOf(id) !== -1;

  const handleClickCheckbox = (event, id) => {
    const selectedIndex = isCheckboxSelected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(isCheckboxSelected, id);
      // getState(true);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(isCheckboxSelected.slice(1));
      // getState(false);
    } else if (selectedIndex === isCheckboxSelected.length - 1) {
      newSelected = newSelected.concat(isCheckboxSelected.slice(0, -1));
      // getState(true);
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        isCheckboxSelected.slice(0, selectedIndex),
        isCheckboxSelected.slice(selectedIndex + 1)
        // getState(false);
      );
    }
    if (newSelected.length !== 0) {
      getState(true);
    } else {
      getState(false);
    }
    setIsCheckboxSelected(newSelected);
    getSelectedId(newSelected);
  };
  const onSelectAllClick = (event) => {
    const newSelecteds = [];
    if (event.target.checked) {
      const newSelecteds = orignalRows.map((n) => n.id);
      setSelected(newSelecteds);
      setIsCheckboxSelected(newSelecteds);
      getState(true);
      getSelectedId(newSelecteds);
      return;
    }
    setIsCheckboxSelected([]);
    getState(false);
    getSelectedId([]);
    if (newSelecteds.length !== 0) {
      getState(true);
    } else {
      getState(false);
    }
  };

  return (
    <>
      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={(searchVal) => cancelSearch(searchVal)}
              onRequestSearch={requestSearching}
              style={{ height: "auto", padding: "5px 0" }}
            />

            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: "10px" }}
              onClick={requestSearching}
              disabled={!searched}
            >
              Search
            </Button>
          </div>

          <div container>
            <div>
              {/* <tab />   // Need To Comment This           */}
              <TablePagination
                rowsPerPageOptions={[10, 50, 100, 500]}
                component="div"
                count={totalRowCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                // style={{width:'27rem'}}
              />
            </div>
          </div>
          {localStorage.getItem("empRole") === "MF Manager" ||
          localStorage.getItem("empRole") === "MF Executive" ||
          localStorage.getItem("empRole") === "Franchise" ? (
            ""
          ) : (
            <div style={{ display: "flex", cursor: "pointer" }}>
              <span onClick={showMenuFilter}>Columns</span>
              <FormControl className={classes.formControl}>
                {/* <InputLabel id="mutiple-select-label"><DehazeIcon /></InputLabel> */}
                {menuCol ? (
                  <div style={{ display: "flex" }}>
                    <Select
                      labelId="mutiple-select-label"
                      multiple
                      value={selected}
                      onChange={handleColChange}
                      // renderValue={(selected) => selected.join(", ")}
                      renderValue={(selected) => null}
                      MenuProps={MenuProps}
                    >
                      {finalDropCols.map((option) => (
                        <MenuItem
                          key={option.headerName}
                          value={option.headerName}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={selected.indexOf(option.headerName) > -1}
                            />
                          </ListItemIcon>
                          <ListItemText primary={option.headerName} />
                        </MenuItem>
                      ))}
                    </Select>
                    <Button
                      style={{ marginLeft: "10px" }}
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={saveColumns}
                    >
                      Save
                    </Button>
                  </div>
                ) : (
                  <FilterListSharpIcon
                    style={{ marginTop: 0 }}
                    onClick={showMenuFilter}
                  />
                )}
              </FormControl>
            </div>
          )}

          <div
            style={{ display: "flex", position: "relative" }}
            className="tfilter"
          >
            Filter
            <div>
              {/* <span
                style={{ margin: "0px 15px", display: "inline-block" }}
              >

              </span> */}
              <SvgIcon
                style={{ cursor: "pointer", verticalAlign: "middle" }}
                onClick={openFilter}
                title={"filter"}
              >
                <FilterLogo />
              </SvgIcon>
              <Filter
                data={passData}
                setOpen={handleMenuClose}
                isMenuOpen={isMenuOpen}
                style={{ border: "3px solid black" }}
              />
              {isFilterOpen ? (
                <div
                  className={[
                    "newfilterstyle",
                    "menupopupfilter",
                    "filter",
                  ].join(" ")}
                >
                  {/* {('am fun', isSelectedData)} */}
                  <div
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      lineHeight: "30px",
                      display: "flex",
                      justifyContent: "center",
                      fontWeight: "bold",
                      cursor: "pointer",
                      background: "#ddd",
                      margin: "5px 0 0 5px",
                    }}
                    onClick={closeFilter}
                  >
                    X
                  </div>
                  <div
                    style={{
                      float: "right",
                      paddingBottom: 10,
                      paddingRight: 40,
                      paddingTop: 10,
                      display: "flex",
                      justifyContent: "flex-end",
                      columnGap: 20,
                      marginBottom: 10,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={clearFilters}
                      color="default"
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      onClick={applyFilters}
                      color="primary"
                    >
                      Apply
                    </Button>
                  </div>
                  {isFilterData.map((filter, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          marginLeft: 20,
                          paddingBottom: 10,
                          paddingTop: 10,
                        }}
                      >
                        <div>
                          <InputLabel style={{ color: "black" }}>
                            {shouldNameDisplay(filter)}
                          </InputLabel>
                        </div>
                        {/* {isSelectedData.map((es) => {
                          return (
                            <>
                              {es.sno} am state
                            </>
                          )
                        })} */}

                        <div style={{ paddingTop: 10 }}>
                          {filter.type === "select" ? (
                            <>
                              <Select
                                labelId="mutiple-select-label"
                                displayEmpty
                                className="select"
                                variant="outlined"
                                multiple
                                style={{ paddingLeft: "5px" }}
                                value={
                                  isSelectedData.find((x) => {
                                    return x.id === filter.id;
                                  })?.options || []
                                }
                                name={filter.name}
                                onChange={(e) => {
                                  handleSelectChange(e.target.value, filter.id);
                                }}
                                // renderValue={(selectedDatas) => selectedDatas.join(", ")}
                                renderValue={(selected) => {
                                  return selected
                                    .map(
                                      (s) =>
                                        filter.options.find(
                                          (x) => x.value === s
                                        )?.name
                                    )
                                    .join(", ");
                                }}

                                // MenuProps={MenuProps}
                              >
                                {filter.options.map((option, index) => (
                                  <MenuItem key={index} value={option.value}>
                                    <ListItemText primary={option.name} />
                                    <ListItemIcon>
                                      <Checkbox
                                        classes={{
                                          root: classes.radio,
                                          checked: classes.checked,
                                        }}
                                        checked={
                                          isSelectedData
                                            .find((x) => x.id === filter.id)
                                            ?.options.indexOf(option.value) !==
                                          -1
                                            ? true
                                            : false
                                        }
                                        style={{ paddingLeft: "5px" }}
                                      />
                                    </ListItemIcon>
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          ) : filter.type === "radio" ? (
                            <>
                              <Select
                                displayEmpty
                                value={
                                  isSelectedData.find((x) => {
                                    return x.id === filter.id;
                                  })?.options
                                }
                                onChange={(e) => {
                                  handleSelectChange(e.target.value, filter.id);
                                }}
                                name={filter.name}
                                className="select"
                                variant="outlined"
                                multiple
                                style={{
                                  backgroundColor: "white",
                                }}
                              >
                                <MenuItem value="">Select</MenuItem>
                                {filter.options.map((option, index) => {
                                  return (
                                    <MenuItem key={index} value={option.value}>
                                      <ListItemText primary={option.name} />
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </>
                          ) : filter.type === "date" ? (
                            <>
                              <Select
                                value={
                                  Object.keys(
                                    isSelectedData.find((x) => {
                                      return x.id === filter.id;
                                    })?.data || {}
                                  )[0]
                                }
                                onChange={(x) =>
                                  handleSelectChange(
                                    x.target.value,
                                    filter.id,
                                    "option"
                                  )
                                }
                                className="select"
                                label={filter.name}
                                style={{
                                  backgroundColor: "white",
                                  marginBottom: 10,
                                }}
                              >
                                <MenuItem value={"equalTo"}>Equal To</MenuItem>
                                <MenuItem value={"lessThan"}>
                                  Less Than
                                </MenuItem>
                                <MenuItem value={"greaterThan"}>
                                  Greater Than
                                </MenuItem>
                                <MenuItem value={"lessThanEqual"}>
                                  Less Than Equal To
                                </MenuItem>
                                <MenuItem value={"greaterThanEqual"}>
                                  Greater Than Equal To
                                </MenuItem>
                                <MenuItem value={"range"}>Range</MenuItem>
                              </Select>
                              {Object.keys(
                                isSelectedData.find((x) => {
                                  // (x);
                                  return x.id === filter.id;
                                })?.data || {}
                              )[0] !== "range" ? (
                                <TextField
                                  type="date"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data[
                                      Object.keys(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data || {}
                                      )[0]
                                    ]
                                  }
                                  inputProps={{
                                    // min: "2020-08-10",
                                    max:
                                      filter.name === "Current Renewal Date" ||
                                      filter.name === "Subscription Date" ||
                                      filter.name === "All Renewal Dates"
                                        ? null
                                        : getCurrentdate,
                                  }}
                                  onChange={(x) =>
                                    handleSelectChange(
                                      x.target.value,
                                      filter.id,
                                      "value"
                                    )
                                  }
                                  className="select"
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                />
                              ) : (
                                // RANGE FIELDS
                                <>
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    From{" "}
                                  </label>
                                  <TextField
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "from"
                                    )}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeFrom"
                                      )
                                    }
                                    inputProps={{
                                      // min: "2020-08-10",
                                      max:
                                        filter.name ===
                                          "Current Renewal Date" ||
                                        filter.name === "Subscription Date" ||
                                        filter.name === "All Renewal Dates"
                                          ? null
                                          : getCurrentdate,
                                    }}
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    To{" "}
                                  </label>
                                  <TextField
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "to"
                                    )}
                                    inputProps={{
                                      // min: "2020-08-10",
                                      max:
                                        filter.name ===
                                          "Current Renewal Date" ||
                                        filter.name === "Subscription Date" ||
                                        filter.name === "All Renewal Dates"
                                          ? null
                                          : getCurrentdate,
                                    }}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeTo"
                                      )
                                    }
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                </>
                              )}
                            </>
                          ) : filter.type === "number" ? (
                            <>
                              <Select
                                value={
                                  Object.keys(
                                    isSelectedData.find((x) => {
                                      return x.id === filter.id;
                                    })?.data || {}
                                  )[0]
                                }
                                onChange={(x) =>
                                  handleSelectChange(
                                    x.target.value,
                                    filter.id,
                                    "option"
                                  )
                                }
                                className="select"
                                label={filter.name}
                                style={{
                                  backgroundColor: "white",
                                  marginBottom: 10,
                                }}
                              >
                                <MenuItem value={"equalTo"}>Equal To</MenuItem>
                                <MenuItem value={"lessThan"}>
                                  Less Than
                                </MenuItem>
                                <MenuItem value={"greaterThan"}>
                                  Greater Than
                                </MenuItem>
                                <MenuItem value={"lessThanEqual"}>
                                  Less Than Equal To
                                </MenuItem>
                                <MenuItem value={"greaterThanEqual"}>
                                  Greater Than Equal To
                                </MenuItem>
                                <MenuItem value={"range"}>Range</MenuItem>
                              </Select>
                              {/* {// ('test1', filter.id)}
                  {// (filterState.find(x=>{// (x);return x.id===filter.id}))}
                  {// ('test2')} */}
                              {Object.keys(
                                isSelectedData.find((x) => {
                                  return x.id === filter.id;
                                })?.data || {}
                              )[0] !== "range" ? (
                                <TextField
                                  type="text"
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={
                                    isSelectedData.find(
                                      (x) => x.id === filter.id
                                    )?.data[
                                      Object.keys(
                                        isSelectedData.find(
                                          (x) => x.id === filter.id
                                        )?.data || {}
                                      )[0]
                                    ]
                                  }
                                  onChange={(x) =>
                                    handleSelectChange(
                                      x.target.value,
                                      filter.id,
                                      "value"
                                    )
                                  }
                                  className="select"
                                  style={{
                                    backgroundColor: "white",
                                  }}
                                />
                              ) : (
                                // RANGE FIELDS
                                <>
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    From{" "}
                                  </label>
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "from"
                                    )}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeFrom"
                                      )
                                    }
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                  <label
                                    style={{
                                      fontSize: 11,
                                      marginBorrom: 10,
                                      display: "block",
                                    }}
                                  >
                                    {" "}
                                    To{" "}
                                  </label>
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    value={parseRangeValue(
                                      isSelectedData.find(
                                        (x) => x.id === filter.id
                                      )?.data[
                                        Object.keys(
                                          isSelectedData.find(
                                            (x) => x.id === filter.id
                                          )?.data || {}
                                        )[0]
                                      ],
                                      "to"
                                    )}
                                    onChange={(x) =>
                                      handleSelectChange(
                                        x.target.value,
                                        filter.id,
                                        "rangeTo"
                                      )
                                    }
                                    className="select"
                                    style={{
                                      backgroundColor: "white",
                                    }}
                                  />
                                </>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {/* 
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    <TableSortLabel
                                    active={orderBy === column.id}
                                    direction={orderBy === column.id ? order : 'asc'}
                                    onClick={e => handleRequestSort(e, column.id, column.format)}
                                >
                                        {column.label}
</TableSortLabel>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row,index) => {
                            return (
                                <TableRow className={classes.tableRow}  hover role="checkbox" tabIndex={-1} key={index+"a"}>
                                    {columns.map((column,index) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={index+column.id} align={column.align}>
                                                {column.format && typeof value === 'number' ?
                                                    Number(value) : (column.id === "detailsButton") ?
                                                        (<Button variant="contained" color="primary" style={{ borderRadius: 20 }} onClick={()=>viewProspectDetails(row)}>
                                                            View Details
                                                        </Button>) :
                                                         (column.format === "boolean" && row[column.id]) ? "Yes" : (column.format === "boolean" && !row[column.id]) ? "No":
                                                        (column.format === "Date") ? getDate(value):
                                                        column.id === "eye" ? (
                          <>
                            <VisibilityIcon
                              onClick={() => viewProspectDetails(row)}
                              style={{ color: "#2835d5" }}
                            />
                          </>
                        ) : column.id === "edit" ? (
                          <>
                            <EditSharpIcon  
                                onClick={() => editInvest(row)}                            
                              style={{
                                color: "#2835d5",
                                borderBottom: "3px solid #2835d5",                                
                              }}
                            />
                          </>
                        ) : (
                          value
                        )
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer> */}

        {/* <MaterialTable
        columns={filteredCol}
        data={orignalRows}
        style={{ fontSize: 12 }}
        onRowClick={(event, rowData) => viewProspectDetails(rowData)}
        options={{ columnsButton: false, search: false, paging: false, pageSizeOptions: [10, 50, 100, 500], actionsColumnIndex: -1 fixedColumns:{left:2} selection: true, filtering: true }}
        title=""
      /> */}

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  padding="checkbox"
                  style={{
                    textAlign: "center",
                  }}
                >
                  {localStorage.getItem("empRole") === "CTO" ||
                  localStorage.getItem("empRole") === "CEO" ||
                  localStorage.getItem("empRole") === "Sales Manager" ||
                  localStorage.getItem("empRole") === "MF Manager" ||
                  localStorage.getItem("empRole") === "Franchise" ? (
                    <Checkbox
                      color="primary"
                      numSelected={isCheckboxSelected.length}
                      style={{ textAlign: "center" }}
                      onChange={onSelectAllClick}
                      inputProps={{
                        "aria-label": "select all desserts",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                {filteredCol.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.headerName}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orignalRows.length !== 0 ? (
                <>
                  {orignalRows
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isSelecteds = isSelected(row.id);
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                          className="prospecttable"
                        >
                          <TableCell padding="checkboox">
                            {localStorage.getItem("empRole") === "CTO" ||
                            localStorage.getItem("empRole") === "CEO" ||
                            localStorage.getItem("empRole") ===
                              "Sales Manager" ||
                            localStorage.getItem("empRole") === "MF Manager" ||
                            localStorage.getItem("empRole") === "Franchise" ? (
                              <Checkbox
                                // indeterminate={numSelected > 0 && numSelected < rowCount}
                                //checked={numSelected === rowCount}
                                // onChange={onSelectAllClick}
                                color="primary"
                                className="selectCheckbox"
                                // checked={numSelected === rowCount}
                                checked={isSelecteds}
                                numSelected={isCheckboxSelected.length}
                                onClick={(event) =>
                                  handleClickCheckbox(event, row.id)
                                }
                              />
                            ) : (
                              ""
                            )}
                          </TableCell>
                          {filteredCol.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                                onDoubleClick={() => viewProspectDetails(row)}
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.id === "detailsButton" ? (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ borderRadius: 20 }}
                                    // onClick={() => viewDetails(row)}
                                  >
                                    View Details
                                  </Button>
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : column.operation &&
                                  column.operation === "concate" ? (
                                  value + column.operand + row[column.with]
                                ) : column.type &&
                                  column.type === "link" &&
                                  value ? (
                                  <Link
                                    variant="body2"
                                    // onClick={(e) => viewDetails(row)}
                                    onClick={(e) => viewProspectDetails(row)}
                                    gutterBottom
                                    style={{ cursor: "pointer" }}
                                  >
                                    {value}
                                  </Link>
                                ) : column.type &&
                                  column.type === "attach" &&
                                  value ? (
                                  <Link
                                    // href={staticFiles + value}
                                    target="_blank"
                                    variant="body2"
                                    gutterBottom
                                    style={{ cursor: "pointer" }}
                                  >
                                    {value}
                                  </Link>
                                ) : column.headerName === "Mobile" ? (
                                  <div
                                    style={{ display: "flex", columnGap: 10 }}
                                  >
                                    <p style={{ width: "80px" }}>{value}</p>
                                    <p>
                                      <CallIcon
                                        style={{ color: "#2835d5" }}
                                        onClick={(e) => openModel(e, row)}
                                      />
                                    </p>
                                  </div>
                                ) : column.headerName ===
                                  "Onboarding Status" ? (
                                  onboardingStatusMap[value]
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Records Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
          {/* <>
            <Rnd
              default={{
                x: 935,
                y: 360,
                height: 'auto'
              }}
              minHeight='auto'
              bounds="parent"
            >
              <div className="boxs">
                <div class="indeterminate-progress-bar">
                  <div class="indeterminate-progress-bar__progress"></div>
                </div>
                <div className="downloading">
                  <div className="export_satatus">
                    <h3>
                      Import/Export Statuss
                    </h3>
                    <div
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        lineHeight: "30px",
                        display: "flex",
                        justifyContent: "center",
                        fontWeight: "bold",
                        cursor: "pointer",
                        background: "#ddd",
                        margin: '10px',
                      }}
                      onClick={handleCloseModal}
                    >
                      X
                    </div>
                  </div>
                  <hr />
                  <p>
                    Export In Progress
                    <span className="currentDay">
                      {currentDay}
                    </span>
                  </p>
                  <p>
                    Module: Propsect - {recordsCount !== 0 ? recordsCount : "ALL"}
                    <span className="currentDay">
                      {currentTime}
                    </span>
                  </p>
                </div>
              </div>
            </Rnd>
          </> */}
          {showProgressBar ? (
            <>
              <Rnd
                default={{
                  x: 935,
                  y: 200,
                  height: "auto",
                }}
                minHeight="auto"
                bounds="parent"
              >
                <div className="boxs">
                  <div class="indeterminate-progress-bar">
                    <div class="indeterminate-progress-bar__progress"></div>
                  </div>
                  <div className="downloading">
                    <div className="export_satatus">
                      <h3>Import/Export Statuss</h3>
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          lineHeight: "30px",
                          display: "flex",
                          justifyContent: "center",
                          fontWeight: "bold",
                          cursor: "pointer",
                          background: "#ddd",
                          margin: "10px",
                        }}
                        onClick={handleCloseModal}
                      >
                        X
                      </div>
                    </div>
                    <hr />
                    <p>
                      Export In Progress
                      <span className="currentDay">{currentDay}</span>
                    </p>
                    <p>
                      Module: Investors -{" "}
                      {recordsCount !== 0 ? recordsCount : "ALL"}
                      <span className="currentDay">{currentTime}</span>
                    </p>
                  </div>
                </div>
              </Rnd>
            </>
          ) : (
            ""
          )}
        </TableContainer>
        <div>
          {/* <tab />   // Need To Comment This           */}
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // style={{width:'27rem'}}
          />
        </div>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="draggable-dialog-title"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent>
            <Typography>Are you sure you want to call?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              No
            </Button>
            <Button
              autoFocus
              onClick={submitCall}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  );
}
export default OnboardingOverView;
